export default __webpack_public_path__ + "static/media/auth.e39e1b50.svg";